'use client';

import { forwardRef, useContext } from 'react';

import { cx } from '@/styled-system/css';

import { Icon } from '../icon/icon';
import { AssistChipContext } from './context/assist-chip.context';
import { assistChipIconStyles } from './styles/assist-chip-icon.styles';
import type { AssistChipIconPropsInterface } from './types/assist-chip-icon.types';

/**
 * @since 10.0.0
 */
export const AssistChipIcon = forwardRef<SVGSVGElement, AssistChipIconPropsInterface>(
  (props, forwardedRef) => {
    const { children, css: cssProp, ...rest } = props;
    const { loading } = useContext(AssistChipContext);

    /*
     * Don't render icon when loading is true
     */
    if (loading) {
      return null;
    }

    return (
      <Icon
        data-c11n-component="AssistChip.Icon"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        css={{ ...assistChipIconStyles, ...cssProp }}
        size="sm"
        {...rest}
        className={cx('c11n_assist-chip__icon', rest.className)}
      >
        {children}
      </Icon>
    );
  },
);

AssistChipIcon.displayName = 'AssistChip.Icon';
